/**
 * Step 2 — Primary goal picker
 *
 * Spec: specs/onboarding-rebuild.md → Act 1 step 2
 *
 * 3 identity-stance options that capture `primary_goal`. Tightened from 6
 * use-case options 2026-05-14 (Mason lock) — identity stance converts
 * better than verb-led use cases. Each slug maps to a calling tagline
 * + paywall trial checklist downstream.
 */

import PrimaryGoalSynthesis from './PrimaryGoalPicker.synthesis'

export const PRIMARY_GOAL_OPTIONS = [
  { value: 'grow_closer', label: 'Grow closer to God' },
  { value: 'know_what_believe', label: 'Know what I believe' },
  { value: 'lead_others', label: 'Lead others' },
]

export default function PrimaryGoalStep({ value, onSelect, onContinue }) {
  return (
    <PrimaryGoalSynthesis
      value={value}
      onSelect={onSelect}
      onContinue={onContinue}
      options={PRIMARY_GOAL_OPTIONS}
    />
  )
}
